import React, { useEffect, useState } from "react";

import { Collapse, FormLabel, Grid } from "@mui/material";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import Button from "../../../components/CustomButtons/Button";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import Testmail from "../Modals/Testmail";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormTextTC from "../../../components/Forms/FormTextTC";
import { useController, useFormContext, useWatch } from "react-hook-form";
import FormFieldTwoColumns from "../../../components/Forms/Layouts/FormFieldTwoColumns";
import Editor from "../../SunEditor";
import FormSwitch from "../../../components/Forms/FormSwitch";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function Mail() {
  const [testMailModal, setTestMailModal] = useState(false);
  const { vestigingId } = useFormContext();

  const {
    field: { value: delivery_settings__headerTicketValue, onChange: delivery_settings__headerTicketOnChange },
  } = useController({ name: "delivery_settings__headerTicket" });

  const {
    field: { value: delivery_settings__centerTicketValue, onChange: delivery_settings__centerTicketOnChange },
  } = useController({ name: "delivery_settings__centerTicket" });

  const {
    field: { value: delivery_settings__preFooterTicketValue, onChange: delivery_settings__preFooterTicketOnChange },
  } = useController({ name: "delivery_settings__preFooterTicket" });

  const {
    field: { value: delivery_settings__footerTicketValue, onChange: delivery_settings__footerTicketOnChange },
  } = useController({ name: "delivery_settings__footerTicket" });

  const {
    field: { value: delivery_settings__headerSalesMailValue, onChange: delivery_settings__headerSalesMailOnChange },
  } = useController({ name: "delivery_settings__headerSalesMail" });

  const {
    field: { value: delivery_settings__footerSalesMailValue, onChange: delivery_settings__footerSalesMailOnChange },
  } = useController({ name: "delivery_settings__footerSalesMail" });

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody style={{ padding: 16, display: "flex", flexWrap: "wrap" }} alignItems={"flex-start"}>
          <Grid container spacing={1} style={{ maxWidth: 1400 }}>
            <Grid item xs={12}>
              <h3>
                <TranslationWrapper tKey={"vestigingen.form.mail.headers.mailsettings"} tDefault={"Mail settings"} />
              </h3>
            </Grid>
            <Grid item xs={12}>
              <Button color={"success"} onClick={() => setTestMailModal(!testMailModal)}>
                <TranslationWrapper tKey={"vestigingen.form.mail.buttons.sendtestmail"} tDefault={"Emails testen"} />
              </Button>
            </Grid>
            {/* <FormSwitchTC
              name={"orderMailRequired"}
              tKey={"vestigingen.form.algemeen.label.orderMailRequired"}
              tDefault={"Order e-mail verplicht"}
            /> */}
            {/* <FormSwitchTC
              name={"sendOrderMail"}
              tKey={"vestigingen.form.algemeen.label.sendOrderMail"}
              tDefault={"Order verzenden per mail"}
            /> */}
            <Grid item xs={12}>
              <h3>
                <TranslationWrapper tKey={"vestigingen.form.mail.headers.templates"} tDefault={"Mail templates"} />
              </h3>
            </Grid>
            <Card>
              <CardBody
                style={{ padding: "0px 0px 0px 16px", display: "flex", flexWrap: "wrap" }}
                alignItems={"flex-start"}
              >
                <Grid item xs={12}>
                  <h4>
                    <strong>
                      <TranslationWrapper
                        tKey={"vestigingen.form.mail.headers.tickettemplate.2"}
                        tDefault={"Mail template Ticket (Confirmation email to buyer)"}
                      />
                    </strong>
                  </h4>
                </Grid>
                <FormTextTC
                  name={"ticketMailTemplate"}
                  tKey={"vestigingen.form.autoreports.label.ticketMailTemplate.2"}
                  tDefault={"Mail template confirmation for buyer (guest)"}
                />
                <FormTextTC
                  name={"extra_settings__mail_from_name"}
                  tKey={"vestigingen.form.autoreports.label.mail_from_name"}
                  tDefault={"Mail from name"}
                />
                <FormTextTC
                  name={"mailSubject"}
                  tKey={"vestigingen.form.autoreports.label.mailSubject"}
                  tDefault={"Mail subject"}
                />
                <FormFieldTwoColumns>
                  <FormLabel>
                    <TranslationWrapper
                      tKey={"vestigingen.form.mail.ticketMailSubject.description"}
                      tDefault={"Usable placeholder variables in mail subject: "}
                    />
                    <span>
                      [name] , [orderId] , [externTransId] , [externOrderId] , [oCnt] , [oCntShort] , [pickupNr]
                    </span>
                  </FormLabel>
                </FormFieldTwoColumns>

                <FormSwitchTC
                  name={"mailVatSpecs"}
                  tKey={"vestigingen.form.delivery_settings.label.delivery_settings__headerTicket"}
                  tDefault={"Show VAT information"}
                />
                {delivery_settings__headerTicketValue !== undefined ? (
                  <Accordion
                    sx={{ width: "100%" }}
                    key={"delivery_settings__headerTicket"}
                    defaultExpanded={!!delivery_settings__headerTicketValue}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <TranslationWrapper
                        tKey={"vestigingen.form.delivery_settings.label.delivery_settings__headerTicket"}
                        tDefault={"Mail header"}
                      />
                    </AccordionSummary>
                    <AccordionDetails>
                      <FormFieldTwoColumns
                        label={
                          <FormLabel>
                            <TranslationWrapper
                              tKey={"vestigingen.form.delivery_settings.label.delivery_settings__headerTicket"}
                              tDefault={"Mail header"}
                            />
                          </FormLabel>
                        }
                      >
                        <Editor
                          key={"delivery_settings__headerTicket"}
                          textareaName="delivery_settings__headerTicket"
                          defaultValue={delivery_settings__headerTicketValue}
                          onChange={delivery_settings__headerTicketOnChange}
                        />
                      </FormFieldTwoColumns>
                    </AccordionDetails>
                  </Accordion>
                ) : null}
                {delivery_settings__centerTicketValue !== undefined ? (
                  <Accordion
                    sx={{ width: "100%" }}
                    key={"delivery_settings__centerTicket"}
                    defaultExpanded={!!delivery_settings__centerTicketValue}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <TranslationWrapper
                        tKey={"vestigingen.form.delivery_settings.label.delivery_settings__centerTicket"}
                        tDefault={"Inhoud tussen customfields en overzicht"}
                      />
                    </AccordionSummary>
                    <AccordionDetails>
                      <FormFieldTwoColumns
                        label={
                          <FormLabel>
                            <TranslationWrapper
                              tKey={"vestigingen.form.delivery_settings.label.delivery_settings__centerTicket"}
                              tDefault={"Inhoud tussen customfields en overzicht"}
                            />
                          </FormLabel>
                        }
                      >
                        <Editor
                          key={"delivery_settings__centerTicket"}
                          textareaName="delivery_settings__centerTicket"
                          defaultValue={delivery_settings__centerTicketValue}
                          onChange={delivery_settings__centerTicketOnChange}
                        />
                      </FormFieldTwoColumns>
                    </AccordionDetails>
                  </Accordion>
                ) : null}
                {delivery_settings__preFooterTicketValue !== undefined ? (
                  <Accordion
                    sx={{ width: "100%" }}
                    key={"delivery_settings__preFooterTicket"}
                    defaultExpanded={!!delivery_settings__preFooterTicketValue}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <TranslationWrapper
                        tKey={"vestigingen.form.delivery_settings.label.delivery_settings__preFooterTicket"}
                        tDefault={"Inhoud tussen overzicht en betaal informatie"}
                      />
                    </AccordionSummary>
                    <AccordionDetails>
                      <FormFieldTwoColumns
                        label={
                          <FormLabel>
                            <TranslationWrapper
                              tKey={"vestigingen.form.delivery_settings.label.delivery_settings__preFooterTicket"}
                              tDefault={"Inhoud tussen overzicht en betaal informatie"}
                            />
                          </FormLabel>
                        }
                      >
                        <Editor
                          key={"delivery_settings__preFooterTicket"}
                          textareaName="delivery_settings__preFooterTicket"
                          defaultValue={delivery_settings__preFooterTicketValue}
                          onChange={delivery_settings__preFooterTicketOnChange}
                        />
                      </FormFieldTwoColumns>
                    </AccordionDetails>
                  </Accordion>
                ) : null}
                {delivery_settings__footerTicketValue !== undefined ? (
                  <Accordion
                    sx={{ width: "100%" }}
                    key={"delivery_settings__footerTicket"}
                    defaultExpanded={!!delivery_settings__footerTicketValue}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <TranslationWrapper
                        tKey={"vestigingen.form.delivery_settings.label.delivery_settings__footerTicket"}
                        tDefault={"Footer"}
                      />
                    </AccordionSummary>
                    <AccordionDetails>
                      <FormFieldTwoColumns
                        label={
                          <FormLabel>
                            <TranslationWrapper
                              tKey={"vestigingen.form.delivery_settings.label.delivery_settings__footerTicket"}
                              tDefault={"Footer"}
                            />
                          </FormLabel>
                        }
                      >
                        <Editor
                          key={"delivery_settings__footerTicket"}
                          textareaName="delivery_settings__footerTicket"
                          defaultValue={delivery_settings__footerTicketValue}
                          onChange={delivery_settings__footerTicketOnChange}
                        />
                      </FormFieldTwoColumns>
                    </AccordionDetails>
                  </Accordion>
                ) : null}
              </CardBody>
            </Card>
            <Card>
              <CardBody style={{ padding: 16, display: "flex", flexWrap: "wrap" }} alignItems={"flex-start"}>
                <Grid item xs={12}>
                  <h4>
                    <strong>
                      <TranslationWrapper
                        tKey={"vestigingen.form.mail.headers.salestemplate.2"}
                        tDefault={"Mail Template | Ticket email to supplier"}
                      />
                    </strong>
                  </h4>
                </Grid>
                <FormTextTC
                  name={"orderMailTemplate"}
                  tKey={"vestigingen.form.autoreports.label.orderMailTemplate.2"}
                  tDefault={"Mail template confirmation for seller (owner)"}
                />
                <FormTextTC
                  name={"delivery_settings__emailSales"}
                  tKey={"vestigingen.form.delivery_settings.label.delivery_settings__emailSales"}
                  tDefault={"Order email adres"}
                />
                <FormFieldTwoColumns>
                  <FormLabel>
                    <TranslationWrapper
                      tKey={"vestigingen.form.delivery_settings.label.emailSales_description"}
                      tDefault={"Gebruik ; voor meerdere mails bijv. info@jamezz.nl;mail@jamezz.nl"}
                    />
                  </FormLabel>
                </FormFieldTwoColumns>
                <FormTextTC
                  name={"extra_settings__bccAddres"}
                  tKey={"vestigingen.form.delivery_settings.label.delivery_settings__emailSalesBCC"}
                  tDefault={"BCC Adres"}
                />
                <FormTextTC
                  name={"salesMailSubject"}
                  tKey={"vestigingen.form.autoreports.label.salesMailSubject"}
                  tDefault={"salesMail subject"}
                />
                <FormFieldTwoColumns>
                  <FormLabel>
                    <TranslationWrapper
                      tKey={"vestigingen.form.mail.ticketMailSubject.description"}
                      tDefault={"Usable placeholder variables in mail subject: "}
                    />
                    <span>[name] , [orderid] , [externtransid] , [externorderid] , [ocnt] , [ocntshort]</span>
                  </FormLabel>
                </FormFieldTwoColumns>
                {delivery_settings__headerSalesMailValue !== undefined ? (
                  <Accordion
                    sx={{ width: "100%" }}
                    key={"delivery_settings__headerSalesMail"}
                    defaultExpanded={!!delivery_settings__headerSalesMailValue}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <TranslationWrapper
                        tKey={"vestigingen.form.delivery_settings.label.delivery_settings__headerSalesMail"}
                        tDefault={"Header sales e-mail"}
                      />
                    </AccordionSummary>
                    <AccordionDetails>
                      <FormFieldTwoColumns
                        label={
                          <FormLabel>
                            <TranslationWrapper
                              tKey={"vestigingen.form.delivery_settings.label.delivery_settings__headerSalesMail"}
                              tDefault={"Header sales e-mail"}
                            />
                          </FormLabel>
                        }
                      >
                        <Editor
                          key={"delivery_settings__footerSalesMail"}
                          textareaName="delivery_settings__footerSalesMail"
                          defaultValue={delivery_settings__headerSalesMailValue}
                          onChange={delivery_settings__headerSalesMailOnChange}
                        />
                      </FormFieldTwoColumns>
                    </AccordionDetails>
                  </Accordion>
                ) : null}
                {delivery_settings__footerSalesMailValue !== undefined ? (
                  <Accordion
                    sx={{ width: "100%" }}
                    key={"delivery_settings__footerSalesMail"}
                    defaultExpanded={!!delivery_settings__footerSalesMailValue}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <TranslationWrapper
                        tKey={"vestigingen.form.delivery_settings.label.delivery_settings__footerSalesMail"}
                        tDefault={"Footer sales e-mail"}
                      />
                    </AccordionSummary>
                    <AccordionDetails>
                      <FormFieldTwoColumns
                        label={
                          <FormLabel>
                            <TranslationWrapper
                              tKey={"vestigingen.form.delivery_settings.label.delivery_settings__footerSalesMail"}
                              tDefault={"Footer sales e-mail"}
                            />
                          </FormLabel>
                        }
                      >
                        <Editor
                          key={"delivery_settings__footerSalesMail"}
                          textareaName="delivery_settings__footerSalesMail"
                          defaultValue={delivery_settings__footerSalesMailValue}
                          onChange={delivery_settings__footerSalesMailOnChange}
                        />
                      </FormFieldTwoColumns>
                    </AccordionDetails>
                  </Accordion>
                ) : null}
              </CardBody>
            </Card>
          </Grid>
        </CardBody>
        <Testmail open={testMailModal} toggle={() => setTestMailModal(!testMailModal)} vestiging_id={vestigingId} />;
      </Card>
    </div>
  );
}

export default Mail;
